/**
 * Sticky boost after an edge press (~100ms @ 60Hz).
 * Mick West / Celeste-style intent buffering — short taps still register.
 */
export class BoostBuffer {
  private ticks = 0;
  private wasHeld = false;

  public sample(held: boolean): boolean {
    if (held && !this.wasHeld) this.ticks = 7;
    this.wasHeld = held;
    if (held) this.ticks = Math.max(this.ticks, 1);
    else if (this.ticks > 0) this.ticks -= 1;
    return held || this.ticks > 0;
  }

  public clear(): void {
    this.ticks = 0;
    this.wasHeld = false;
  }
}
